import React from "react"

export type CollapsibleContextType = {
  isCollapsed: boolean
  isCollapsible: boolean
  onToggleCollapsed?: () => void
}

export const CollapsibleContext = React.createContext<CollapsibleContextType>({
  isCollapsed: true,
  isCollapsible: false,
})
